/**
 * Palm Heist Configuration
 * 
 * Central configuration file for environment-specific settings
 * Used for API endpoints, IPFS gateways, and other environment variables
 */

// Environment detection
const isProduction = process.env.NODE_ENV === 'production';
const isTestnet = process.env.REACT_APP_NETWORK === 'testnet';

// Network configuration
export const SOLANA_NETWORK = isProduction 
  ? 'mainnet-beta' 
  : (isTestnet ? 'testnet' : 'devnet');

// API endpoints
export const API_ENDPOINTS = {
  // Backend API (Akash hosted)
  GAME_API: isProduction 
    ? 'https://api.palmheist.io/game'
    : 'http://localhost:3001/game',
  
  AUTH_API: isProduction 
    ? 'https://api.palmheist.io/auth'
    : 'http://localhost:3001/auth',
  
  // IPFS endpoints
  IPFS_GATEWAY: 'https://gateway.lighthouse.storage/ipfs/',
  
  // Asset endpoints
  ASSET_URL: isProduction
    ? 'https://arweave.net/'
    : 'https://gateway.lighthouse.storage/ipfs/',
};

// Game configuration
export const GAME_CONFIG = {
  DAILY_BONUS_COOLDOWN: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
  MAX_CARDS: 12,
  CARD_REVEAL_DELAY: 500, // ms
};

// Social media links
export const SOCIAL_LINKS = {
  TWITTER: 'https://twitter.com/palmheist',
  DISCORD: 'https://discord.gg/palmheist',
  GITHUB: 'https://github.com/linkln33',
};

// Feature flags
export const FEATURES = {
  ENABLE_DAO: isProduction,
  ENABLE_STAKING: isProduction,
  ENABLE_MARKETPLACE: true,
  ENABLE_DAILY_BONUS: true,
};

export default {
  API_ENDPOINTS,
  GAME_CONFIG,
  SOCIAL_LINKS,
  FEATURES,
  SOLANA_NETWORK,
};
